export default __webpack_public_path__ + "static/media/donar-a.4c2dcb37.svg";